import React from "react"
import { StaticQuery, graphql } from "gatsby"

import {
  StyledSkills,
  StyledSkillsList,
  StyledSkillsTitle,
  StyledSkillsProps,
  StyledSkill,
} from "./partials"

export interface SkillsProps extends StyledSkillsProps {
  title: string
  skills: string[]
}

export const SkillsCmp: React.FC<SkillsProps> = ({
  title,
  skillStyle,
  skills,
}) => (
  <>
    <StaticQuery
      query={graphql`
        query {
          allStoryblokDatasourceEntry(
            filter: { data_source: { eq: "curriculumSkillsBBA" } }
          ) {
            edges {
              node {
                id
                name
                value
                data_source
              }
            }
          }
        }
      `}
      render={(data) => {
        return (
          <StyledSkills>
            {title && <StyledSkillsTitle>{title}</StyledSkillsTitle>}
            <StyledSkillsList>
              {skills &&
                skills.map((s) => (
                  <StyledSkill skillStyle={skillStyle} key={s}>
                    {data.allStoryblokDatasourceEntry.edges.find((skill: any) => skill.node.value === s)?.node.name}
                  </StyledSkill>
                ))}
            </StyledSkillsList>
          </StyledSkills>
        )
      }}
    />
  </>
)
